import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  PreviewAltCard,
  Row,
  TooltipComponent,
} from "../../components/Component";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  UncontrolledDropdown,
} from "reactstrap";

import {
  createPrakrityRecommendation,
  getProductDDAPI,
  listPrakrityRecommendationAPI,
  updatePrakrityRecommndationAPI,
} from "../../api/master/indes";

import { toast } from "react-toastify";

import MyButton from "../../MyComp/UI/form/MyButton";

import useLogout from "../../hooks/useLogout";

import MultiSelect from "../../MyComp/UI/form/MultiSelect";
import MyCreateSelect from "../../MyComp/UI/form/MyCreateSelect";
import { truncate, truncate1 } from "../../utils/Utils";

const Recommendation = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
    },
  });

  const logout = useLogout();
  const [currentPage, setCurrentPage] = useState(1);
  // const [itemPerPage] = useState(5);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const renderBadges = (value, color) => {
    if (!value || value === "-") return <span>-</span>;

    return value.split(",").map((item, i) => (
      <span
        key={i}
        className={`badge bg-${color} border border-${color} text-${color} bg-transparent me-1 mb-1`}
        // className={`badge bg-${color}  border border-${color} me-1 mb-1`}
        style={{ fontSize: "12px" }}
        title={item}
      >
        {/* {item?.trim()} */}
        {truncate1(item,10)}

      </span>
    ));
  };
const filteredData = data.filter((row) => {
  if (!searchText) return true;

  const search = searchText.toLowerCase();

  return (
    row.category?.toLowerCase().includes(search) ||
    row.aaharPrefer?.toLowerCase().includes(search) ||
    row.aaharAvoid?.toLowerCase().includes(search) ||
    row.viharPrefer?.toLowerCase().includes(search) ||
    row.viharAvoid?.toLowerCase().includes(search) ||
    row.chikitsaPrefer?.toLowerCase().includes(search) ||
    row.recommended_products?.toLowerCase().includes(search)
  );
});

  useEffect(() => {
    getProductDD();
  }, []);
  const getProductDD = () => {
    getProductDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("recommendedProduct", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("recommendedProduct", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  useEffect(() => {
    prakrityRecommendation();
  }, []);
  const transformPrakrityData = (apiArray = []) => {
    return apiArray.map((prakrity) => {
      const collect = (arr, key) => arr?.flatMap((i) => (Array.isArray(i[key]) ? i[key] : [])).filter(Boolean);

      const collectProducts = (arr) =>
        arr
          ?.flatMap((i) =>
            Array.isArray(i.description)
              ? i.description.filter((d) => typeof d === "object" && d?.label).map((d) => d.label)
              : []
          )
          .filter(Boolean);
const uniqueProducts = Array.from(
  new Set([
    ...collectProducts(prakrity.AAHAR),
    ...collectProducts(prakrity.VIHAR),
    ...collectProducts(prakrity.CHIKITSA),
  ])
);

return {
  category: prakrity.title || "-",

  aaharPrefer: collect(prakrity.AAHAR, "prefer").join(", ") || "-",
  aaharAvoid: collect(prakrity.AAHAR, "avoid").join(", ") || "-",

  viharPrefer: collect(prakrity.VIHAR, "prefer").join(", ") || "-",
  viharAvoid: collect(prakrity.VIHAR, "avoid").join(", ") || "-",

  chikitsaPrefer: collect(prakrity.CHIKITSA, "prefer").join(", ") || "-",

 
  recommended_products: uniqueProducts.length > 0 ? uniqueProducts.join(", ") : "-",
};

    });
  };

  const prakrityRecommendation = () => {
    setValue("isLoading", true);

    listPrakrityRecommendationAPI()
      .then((res) => {
        if (res?.data?.status === true) {
          const apiData = res?.data?.data || [];

          const tableData = transformPrakrityData(apiData);

          setData(tableData);
        } else {
          setData([]);
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };

  const resetF = () => {
    setMode("Add");
    setValue("prakrity_recommendation", "");
    setValue("life_style_prefer", "");
    setValue("life_style_avoid", "");
    setValue("recommended_foods_prefer", "");
    setValue("recommended_foods_avoid", "");
    setValue("ayurveda_treatment", "");
    setValue("recommended_products","")
  };

  const recommendationData = [
    { value: "Vata", label: "Vata" },
    { value: "Pitta", label: "Pitta" },
    { value: "Kapha", label: "Kapha" },
  ];
  const handleEdit = (row) => {
    window.scrollTo(0, 0);

    setValue("selectedRow", row);
setValue(
  "recommended_products",
  row?.recommended_products && row.recommended_products !== "-"
    ? Array.from(new Set(row.recommended_products.split(","))).map((item) => ({
        label: item.trim(),
        value: item.trim(),
      }))
    : []
);

    setValue("prakrity_recommendation", row?.category ? [{ label: row.category, value: row.category }] : []);

    // setValue(
    //   "recommended_products",
    //   row?.recommended_products && row.recommended_products !== "-"
    //     ? row.recommended_products.split(",").map((item) => ({
    //         label: item.trim(),
    //         value: item.trim(),
    //       }))
    //     : []
    // );

    setValue(
      "recommended_foods_prefer",
      row?.aaharPrefer && row.aaharPrefer !== "-"
        ? row.aaharPrefer.split(",").map((i) => ({
            label: i.trim(),
            value: i.trim(),
          }))
        : []
    );

    setValue(
      "recommended_foods_avoid",
      row?.aaharAvoid && row.aaharAvoid !== "-"
        ? row.aaharAvoid.split(",").map((i) => ({
            label: i.trim(),
            value: i.trim(),
          }))
        : []
    );

    setValue(
      "life_style_prefer",
      row?.viharPrefer && row.viharPrefer !== "-"
        ? row.viharPrefer.split(",").map((i) => ({
            label: i.trim(),
            value: i.trim(),
          }))
        : []
    );

    setValue(
      "life_style_avoid",
      row?.viharAvoid && row.viharAvoid !== "-"
        ? row.viharAvoid.split(",").map((i) => ({
            label: i.trim(),
            value: i.trim(),
          }))
        : []
    );

    setValue(
      "ayurveda_treatment",
      row?.chikitsaPrefer && row.chikitsaPrefer !== "-"
        ? row.chikitsaPrefer.split(",").map((i) => ({
            label: i.trim(),
            value: i.trim(),
          }))
        : []
    );

    setMode("Edit");
    setIsOpen(true);
  };

  const onFormSubmit = (formData) => {
    console.log(formData, "khdhghjj");

    const payload = {
      recommended_products: formData?.recommended_products,
      prakriti_type:
        formData?.prakrity_recommendation?.length > 0
          ? formData.prakrity_recommendation.map((i) => i.value).join("-")
          : "",
  //     prakriti_type:
  // formData?.prakrity_recommendation?.length > 0
  //   ? formData.prakrity_recommendation.map((i) => i.value)
  //   : [],


      data: [
        {
          section: "AAHAR",
          prefer: formData?.recommended_foods_prefer ? formData.recommended_foods_prefer.map((i) => i.value) : [],
          avoid: formData?.recommended_foods_avoid ? formData.recommended_foods_avoid.map((i) => i.value) : [],
        },
        {
          section: "VIHAR",
          prefer: formData?.life_style_prefer ? formData.life_style_prefer.map((i) => i.value) : [],
          avoid: formData?.life_style_avoid ? formData.life_style_avoid.map((i) => i.value) : [],
        },
        {
          section: "CHIKITSA",
          prefer: formData?.ayurveda_treatment ? formData.ayurveda_treatment.map((i) => i.value) : [],
          avoid: [],
        },
      ],
    };

    const apiCall = mode === "Edit" ? createPrakrityRecommendation(payload) : createPrakrityRecommendation(payload);

    apiCall
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(res?.data?.message);
          prakrityRecommendation();
          setIsOpen(false);
          resetF();
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message));
  };

  return (
    <>
      <Head title={"Prakrity | Master"} />

      <>
        {" "}
        <>
          <Head title="Prakrity Recommendation" />

          <Content>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {"Prakrity Recommendation"}
                  </BlockTitle>
                </BlockHeadContent>
                <BlockHeadContent className="d-flex gap-5   align-items-center">
                  <div className="form-control-wrap d-flex align-items-center">
                    <div className="form-icon form-icon-right">
                      <Icon name="search"></Icon>
                    </div>
                    <input
                      type="text"
                      className="form-control p-1"
                      placeholder={`Search by title`}
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                      style={{ minWidth: "250px" }}
                    />
                  </div>
                  <div className="">
                    <Button
                      color="primary"
                      outline
                      className={` bg-primary text-white`}
                      onClick={() => {
                        if (toggleCanvas) {
                          toggleCanvas();
                        } else {
                          setIsOpen(!isOpen);
                        }

                        resetF();
                      }}
                      // onClick={toggleCanvas}
                    >
                      <Icon name={isOpen ? "minus" : "plus"} />
                    </Button>
                    
                   
                  </div>
                   {/* <UncontrolledDropdown>
                      <DropdownToggle
                        color="transparent"
                        className="dropdown-toggle dropdown-indicator btn btn-outline-primary btn-white"
                      >
                        Show {itemPerPage}
                      </DropdownToggle>
                  
                      <DropdownMenu end>
                        {[5, 10, 20, 50].map((size) => (
                          <DropdownItem
                            key={size}
                            onClick={() => {
                              setItemPerPage(size);
                              setCurrentPage(1);
                            }}
                          >
                            {size} rows
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </UncontrolledDropdown> */}
                </BlockHeadContent>
              </BlockBetween>
            </BlockHead>
            <Block>
              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Prakrity Recommendation</OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      {" "}
                      <Row>
                        <Col md={12}>
                          <MultiSelect
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title="Prakrity Recommendation"
                            name="prakrity_recommendation"
                            placeholder="Select prakrity recommendation"
                            required
                            options={recommendationData}
                          />
                        </Col>

                        <Row>
                          <h5 className="mt-5 mb-0">Life Style (Vihar)</h5>
                          <Col md="12" className={``}>
                            <MyCreateSelect
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              title={"Life Style Prefer"}
                              name={"life_style_prefer"}
                              placeholder={"Create life style "}
                              multi
                            />
                          </Col>
                          <Col md="12" className={``}>
                            <MyCreateSelect
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              title={"Life Style avoid"}
                              name={"life_style_avoid"}
                              placeholder={"Create life style "}
                              multi
                            />
                          </Col>
                        </Row>
                        <Row>
                          <h5 className="mt-3">Recommended Food(Aahar)</h5>
                          <Col md="12" className={``}>
                            <MyCreateSelect
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              title={"Recommended Food  Prefer "}
                              name={"recommended_foods_prefer"}
                              placeholder={"Create recommended foods "}
                              multi
                            />
                          </Col>
                          <Col md="12" className={``}>
                            <MyCreateSelect
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              title={"Recommended Foods Avoid"}
                              name={"recommended_foods_avoid"}
                              placeholder={"Create recommended foods "}
                              multi
                            />
                          </Col>
                        </Row>
                        <Row>
                          <h5 className="mt-3">Ayurveda Treatment Foods(Chikitsa)</h5>
                          <Col md="12" className={``}>
                            <MyCreateSelect
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              title={"Ayurveda Treatment Foods"}
                              name={"ayurveda_treatment"}
                              placeholder={"Create ayurveda treatment"}
                              required
                              multi
                            />
                          </Col>
                        </Row>

                        <Col md={12}>
                          <MultiSelect
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title=" Recommended Products"
                            name="recommended_products"
                            placeholder="Select recommended products"
                            required
                            options={watch("recommendedProduct")}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton mode={mode} isLoading={isLoading} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>
              
              <div className="text-start  m-auto p-auto">
                <div className="row nk-tb-list is-medium mb-3 text-start ms-0" style={{ background: "white" }}>
                  <DataTableHead
                    style={{
                      background: "white",
                      borderBottom: "1px solid #e5e9f2",
                      fontWeight: "700",
                    }}
                  >
                    <DataTableRow className="text-start" style={{width:"100px"}}>
                      <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                        Prakrity Recommendation
                      </span>
                    </DataTableRow>
                    <DataTableRow className="text-start">
                      <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                        AAHAR (Prefer | Avoid)
                      </span>
                    </DataTableRow>
                    <DataTableRow className="text-start">
                      <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                        VIHAR (Prefer | Avoid)
                      </span>
                    </DataTableRow>
                    <DataTableRow className="text-start">
                      <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                        CHIKITSA (Prefer)
                      </span>
                    </DataTableRow>
                    <DataTableRow className="text-start">
                      <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                        Recommended Products
                      </span>
                    </DataTableRow>
                    <DataTableRow className="text-center">
                      <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                        Action
                      </span>
                    </DataTableRow>
                  </DataTableHead>
                  {filteredData.length > 0 ? (
                    filteredData.map((row, index) => (
                      <DataTableItem className={"hover-row align-middle w-25 text-start "} key={index}>
                        <DataTableRow className="text-start" style={{width:"100px"}}>{row.category}</DataTableRow>

                        <DataTableRow className={"text-start"}>
                          <div className="text-wrap">
                            <strong>Prefer:</strong> {renderBadges(row.aaharPrefer, "primary")}
                          </div>
                          <div className="mt-1 outline">
                            <strong>Avoid:</strong> {renderBadges(row.aaharAvoid, "danger")}
                          </div>
                        </DataTableRow>

                        <DataTableRow className={"text-start"}>
                          <div>
                            <strong>Prefer:</strong> {renderBadges(row.viharPrefer, "primary")}
                          </div>
                          <div className="mt-1">
                            <strong>Avoid:</strong> {renderBadges(row.viharAvoid, "danger")}
                          </div>
                        </DataTableRow>

                         <DataTableRow>{renderBadges(row.chikitsaPrefer, "primary")} </DataTableRow>

                        <DataTableRow className={"text-start"}>
                          {renderBadges(row.recommended_products, "success")}
                        </DataTableRow>

                        <DataTableRow className={"text-start"}>
                          <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                              <Icon name="more-h" />
                            </DropdownToggle>
                            <DropdownMenu end>
                              <DropdownItem
                              className="p-2"
                                onClick={() => {
                                  handleEdit(row);
                                }}
                              >
                                <Icon className="fs-5 "name="edit" />
                                <span className="fs-6 ms-1">Edit</span>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </DataTableRow>
                      </DataTableItem>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </div>
                <div className="text-start">
                  {filteredData?.length > 0 && (
                    <PreviewAltCard className="border-top w-100 m-auto p-auto text-start">
                      <PaginationComponent
                        itemPerPage={itemPerPage}
                        totalItems={data.length}
                        paginate={paginate}
                        currentPage={currentPage}
                      />
                    </PreviewAltCard>
                  )}
                </div>
              </div>
              
              {/* <div className="mt-5">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Prakrity Recommendation</th>
                      <th>AAHAR (Prefer | Avoid)</th>
                      <th>VIHAR (Prefer | Avoid)</th>
                      <th>CHIKITSA (Prefer)</th>
                      <th>Recommended Products</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.length > 0 ? (
                      data.map((row, index) => (
                        <tr key={index}>
                          <th>{row.category}</th>

                          <td>
                            <div>
                              <strong>Prefer:</strong> {renderBadges(row.aaharPrefer, "primary")}
                            </div>
                            <div className="mt-1 outline">
                              <strong>Avoid:</strong> {renderBadges(row.aaharAvoid, "danger")}
                            </div>
                          </td>

                          <td>
                            <div>
                              <strong>Prefer:</strong> {renderBadges(row.viharPrefer, "primary")}
                            </div>
                            <div className="mt-1">
                              <strong>Avoid:</strong> {renderBadges(row.viharAvoid, "danger")}
                            </div>
                          </td>

                          <td>{renderBadges(row.chikitsaPrefer, "primary")}</td>

                          <td>{renderBadges(row.recommended_products, "success")}</td>

                          <td>
                            <UncontrolledDropdown>
                              <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                <Icon name="more-h" />
                              </DropdownToggle>
                              <DropdownMenu end>
                                <DropdownItem
                                  onClick={() => {
                                    handleEdit(row);
                                  }}
                                >
                                  <Icon name="edit" />
                                  <span>Edit</span>
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div> */}
            </Block>
          </Content>
        </>
      </>
    </>
  );
};

export default Recommendation;
